import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { bookieAPI } from '../../services/api';
import './SettingsPage.css';

function BookieAccounts() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [accounts, setAccounts] = useState([]);
  const [message, setMessage] = useState({ type: '', text: '' });

  useEffect(() => {
    loadBookieAccounts();
  }, []);

  const loadBookieAccounts = async () => {
    try {
      setLoading(true);
      const data = await bookieAPI.getBookieAccounts();
      setAccounts(data.accounts || []);
    } catch (error) {
      setMessage({
        type: 'error',
        text: error.response?.data?.message || 'Failed to load bookie accounts',
      });
    } finally {
      setLoading(false);
    }
  };

  const handleUnlink = async (accountId, bookieName) => {
    if (!window.confirm(`Are you sure you want to unlink your ${bookieName} account?`)) {
      return;
    }

    try {
      await bookieAPI.unlinkBookieAccount(accountId);
      setMessage({
        type: 'success',
        text: `${bookieName} account unlinked successfully`,
      });
      loadBookieAccounts();
    } catch (error) {
      setMessage({
        type: 'error',
        text: error.response?.data?.message || 'Failed to unlink account',
      });
    }
  };

  const handleLinkNew = () => {
    navigate('/register/link');
  };

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  return (
    <div className="settings-page-content">
      <h2>Bookie Accounts</h2>
      <p className="page-description">
        Manage your connected bookie accounts for club betting.
      </p>

      {message.text && (
        <div className={`message ${message.type}`}>{message.text}</div>
      )}

      <div className="form-section">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
          <h3>Connected Accounts</h3>
          <button onClick={handleLinkNew} className="btn btn-primary">
            + Link New Account
          </button>
        </div>

        {accounts.length === 0 ? (
          <div className="empty-state">
            <div className="empty-state-icon">🎰</div>
            <h3>No Bookie Accounts Connected</h3>
            <p>Link a bookie account to start betting with your clubs</p>
            <button onClick={handleLinkNew} className="btn btn-primary">
              Link Your First Account
            </button>
          </div>
        ) : (
          <div className="item-list">
            {accounts.map((account) => (
              <div key={account.id} className="item-card">
                <div className="item-info">
                  <h4>{account.bookieName}</h4>
                  <p>
                    Account ID: {account.clientId || 'N/A'} •{' '}
                    Status: <span style={{ color: account.status === 'OPEN' ? 'green' : 'orange' }}>
                      {account.status}
                    </span>
                  </p>
                  <p style={{ fontSize: '12px', color: '#999', marginTop: '4px' }}>
                    Linked: {new Date(account.created).toLocaleDateString()}
                  </p>
                </div>
                <div className="item-actions">
                  <button
                    onClick={() => handleUnlink(account.id, account.bookieName)}
                    className="btn btn-danger"
                  >
                    Unlink
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      <div className="info-box" style={{ marginTop: '30px' }}>
        <p>
          <strong>Note:</strong> Unlinking a bookie account will remove your ability
          to place bets through clubs using that bookie. Any existing bet history will
          be preserved.
        </p>
      </div>
    </div>
  );
}

export default BookieAccounts;
